// extracted by mini-css-extract-plugin
export default {"footerWrapper":"DDBiud","notificationWrapper":"GKGpdR","footerContainer":"ten9h3"};